import { render, staticRenderFns } from "./TournamentSideBarHeader.vue?vue&type=template&id=6f9a246a&"
import script from "./TournamentSideBarHeader.vue?vue&type=script&lang=js&"
export * from "./TournamentSideBarHeader.vue?vue&type=script&lang=js&"
import style0 from "./TournamentSideBarHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9a246a')) {
      api.createRecord('6f9a246a', component.options)
    } else {
      api.reload('6f9a246a', component.options)
    }
    module.hot.accept("./TournamentSideBarHeader.vue?vue&type=template&id=6f9a246a&", function () {
      api.rerender('6f9a246a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentSideBarHeader.vue"
export default component.exports